import React from 'react';
import OptimizationResults from './OptimizationResults';
import PortfolioChart from './PortfolioChart';
import PerformanceMetrics from './PerformanceMetrics';
import './ResultsPage.css';

const ResultsPage = ({ results, navData, selectedFunds, onStartOver, onGoBack, onRunBacktest }) => {
  return (
    <div className="results-page">
      <div className="results-header">
        <h1>
          <svg className="target-icon" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              {/* Gold gradient for rings */}
              <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#D4A94D"/>
                <stop offset="50%" stopColor="#B8860B"/>
                <stop offset="100%" stopColor="#8B6914"/>
              </linearGradient>
              {/* Dart shaft gradient - silver */}
              <linearGradient id="shaftGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#E8E8E8"/>
                <stop offset="30%" stopColor="#C0C0C0"/>
                <stop offset="60%" stopColor="#A8A8A8"/>
                <stop offset="100%" stopColor="#707070"/>
              </linearGradient>
              {/* Drop shadow */}
              <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="1" dy="1" stdDeviation="1" floodOpacity="0.3"/>
              </filter>
            </defs>
            {/* Target board shadow */}
            <ellipse cx="27" cy="27" rx="20" ry="18" fill="rgba(0,0,0,0.2)"/>
            {/* Target board - outer */}
            <ellipse cx="26" cy="26" rx="20" ry="18" fill="#1a1a1a" stroke="url(#goldGrad)" strokeWidth="2"/>
            {/* Ring 3 */}
            <ellipse cx="26" cy="26" rx="15" ry="13.5" fill="none" stroke="url(#goldGrad)" strokeWidth="1.5"/>
            {/* Ring 2 */}
            <ellipse cx="26" cy="26" rx="10" ry="9" fill="none" stroke="url(#goldGrad)" strokeWidth="1.5"/>
            {/* Ring 1 */}
            <ellipse cx="26" cy="26" rx="5" ry="4.5" fill="none" stroke="url(#goldGrad)" strokeWidth="1.5"/>
            {/* Bullseye */}
            <ellipse cx="26" cy="26" rx="2" ry="1.8" fill="#B8860B"/>
            {/* Dart shadow */}
            <path d="M10 12 L24 26 L26 24 L12 10 Z" fill="rgba(0,0,0,0.2)"/>
            {/* Dart body - traditional shape in gold */}
            <path d="M6 6 L9 5 Q13 7 15 9 L17 11 Q18 13 17 15 L21 19 L24 22 L22 24 L19 21 L15 17 Q13 18 11 17 L9 15 Q7 13 5 9 L6 6 Z"
                  fill="url(#goldGrad)" filter="url(#shadow)"/>
            {/* Dart highlight */}
            <path d="M7 6 L9 6 Q11 8 12 10 L10 12 Q8 10 7 8 Z" fill="#D4A94D" opacity="0.7"/>
            {/* Dart tip */}
            <path d="M22 22 L27 24 L26 26 L24 27 L22 22 Z" fill="#8B6914"/>
            {/* Dart tip point */}
            <path d="M24 24 L26 26 L28 25 L26 23 Z" fill="#6B5210"/>
            {/* Fletching - three feathers in AllocQ teal */}
            <path d="M5 5 L2 -1 L8 4 Z" fill="#0D9488"/>
            <path d="M5 5 L-1 2 L4 8 Z" fill="#14B8A6"/>
            <path d="M5 5 L0 -1 L6 5 Z" fill="#5EEAD4"/>
            {/* Fletching shadows */}
            <path d="M5 5 L3 1 L6 4 Z" fill="#115E59"/>
            <path d="M5 5 L1 3 L4 6 Z" fill="#0F766E"/>
          </svg>
          Optimization Results
        </h1>
        <p>Your optimized portfolio allocation based on Modern Portfolio Theory</p>
      </div>

      <div className="results-content">
        {/* Optimization Results Card */}
        <div className="results-section">
          <OptimizationResults results={results} selectedFunds={selectedFunds} />
        </div>

        {/* Portfolio Chart */}
        {navData && (
          <div className="results-section">
            <h2>📊 Portfolio Visualization</h2>
            <PortfolioChart
              navData={navData}
              weights={results.weights}
            />
          </div>
        )}

        {/* Performance Metrics */}
        {results.risk_metrics && (
          <div className="results-section">
            <h2>📈 Performance Metrics</h2>
            <PerformanceMetrics
              results={results}
              riskMetrics={results.risk_metrics}
              onRunBacktest={onRunBacktest}
            />
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="results-actions">
        <button className="btn-secondary" onClick={onGoBack}>
          ← Modify Parameters
        </button>
        <button className="btn-primary" onClick={onStartOver}>
          🔄 Start Over
        </button>
      </div>
    </div>
  );
};

export default ResultsPage;
